type Props = {
  message?: string;
}

export function CompraSpinner({ message = 'Procesando compra...' }: Props) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[200px] space-y-4">
      {/* Spinner principal */}
      <div className="relative w-16 h-16">
        {/* Círculo exterior giratorio */}
        <div className="absolute inset-0 border-4 border-primary-300/30 rounded-full"></div>
        <div className="absolute inset-0 border-4 border-transparent border-t-primary-200 rounded-full animate-spin"></div>

        {/* Círculo interior giratorio (más lento) */}
        <div className="absolute inset-2 border-4 border-primary-300/30 rounded-full"></div>
        <div className="absolute inset-2 border-4 border-transparent border-t-primary-100 rounded-full animate-spin" style={{ animationDirection: 'reverse', animationDuration: '1.5s' }}></div>
      </div>

      {/* Texto de carga dinámico */}
      <p className="text-white/90 text-sm font-medium animate-pulse">
        {message}
      </p>
    </div>
  );
}